import Vue from 'vue'
import shortid from 'shortid'
const infrustructureIconOptions = {
  options: {
    iconSize: [46, 46],
    shadowSize: [0, 0],
    iconAnchor: [23, 23],
    shadowAnchor: [0, 0],
    popupAnchor: [0, -23]
  }
}
export function mobileCheck() {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    (/Safari[\/\s](\d+\.\d+)/.test(navigator.userAgent) && 'ontouchstart' in window)
  )
}

export function secondsToHHMMSS(time) {
  const h = Math.floor(time / 3600)
  const min = Math.floor((time - h * 3600) / 60)
  const ss = time - h * 3600 - min * 60
  const hText = h > 0 ? (h < 10 ? '0' + h + ':' : h + ':') : ''
  const mText = min < 10 ? '0' + min + ':' : min + ':'
  const sText = ss < 10 ? '0' + ss : ss
  return `${hText}${mText}${sText}`
}

export function random_rgba() {
  let o = Math.round,
    r = Math.random,
    s = 255
  let color = 'rgba(' + o(r() * s) + ',' + o(r() * s) + ',' + o(r() * s) + ',' + r().toFixed(1) + ')'
  return color
}
export function random_rgb() {
  var o = Math.round,
    r = Math.random,
    s = 255
  return 'rgb(' + o(r() * s) + ',' + o(r() * s) + ',' + o(r() * s) + ')'
}

export function getAvgColor(colorsArr) {
  const rgbArr = colorsArr.map((v) => v.match(/\w\w/g).map((c) => parseInt(c, 16)))
  const amount = 1 / colorsArr.length

  let r = rgbArr[0][0]
  let g = rgbArr[0][1]
  let b = rgbArr[0][2]
  const colorCalc = (c1, c2, amount) => Math.round(c1 + (c2 - c1) * amount)

  for (let i = 1; i <= rgbArr.length - 1; i++) {
    r = colorCalc(r, rgbArr[i][0], amount)
    g = colorCalc(g, rgbArr[i][1], amount)
    b = colorCalc(b, rgbArr[i][2], amount)
  }
  const result = '#' + r.toString(16).padStart(2, '0') + g.toString(16).padStart(2, '0') + b.toString(16).padStart(2, '0')
  return result
}

export function getMaxOfArray(numArray) {
  return Math.max.apply(null, numArray)
}

export function getMinOfArray(numArray) {
  return Math.min.apply(null, numArray)
}

export function replaceArrayElement(array, from, to) {
  array.splice(to, 0, array.splice(from, 1)[0])
}

export function convertArrayToObject(array, key) {
  const initialValue = {}
  array.forEach((v) => {
    initialValue[v[key]] = v
  })
  return initialValue
}

export function toDataURL(url, callback) {
  var xhr = new XMLHttpRequest()
  xhr.onload = () => {
    var reader = new FileReader()
    reader.onloadend = function() {
      callback(reader.result)
    }
    reader.readAsDataURL(xhr.response)
  }
  xhr.onerror = () => {
    callback('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=')
  }
  xhr.open('GET', url)
  xhr.responseType = 'blob'
  xhr.send()
}

export function svgLeafletIcon(leafletIconClass, color) {
  const CustomIcon = leafletIconClass.extend({
    options: {
      iconSize: [40, 40],
      shadowSize: [0, 0],
      iconAnchor: [20, 20],
      shadowAnchor: [0, 0],
      popupAnchor: [0, -20]
    }
  })

  const svgrect =
    '<svg viewBox="0 0 120 120" width="120" height="120" xmlns="http://www.w3.org/2000/svg"><circle cx="60" cy="60" r="50" fill="' + color + '"/></svg>'
  const url = encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')

  return new CustomIcon({ iconUrl: url })
}

export function svgLeafletInfoIcon(leaflet, iconPath) {
  return leaflet.divIcon({
    className: '',
    iconSize: [46, 46],
    html:
      '<div style="position:relative;width:46px;height:46px;background:#fff;border-radius:50%;display: flex;align-items: center;justify-content: center"><img src="' +
      iconPath +
      '" style="display: block;max-width: 30px; max-height: 30px; width: auto; height: auto;"></div>'
  })
}
export function svgLeafletInfo(iconPath) {
  const svgrect =
    '<svg viewBox="0 0 46 46" width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="23" cy="23" r="19" fill="#fff"/><circle cx="23" cy="23" r="18" stroke="#FDFEFD" stroke-width="2"/></g><image href="' +
    iconPath +
    '" width="30" height="30" x="8" y="8" stroke="#FDFEFD" stroke-width="2"/><defs><filter id="filter0_d" x="0" y="0" width="46" height="46" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0.12 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>'
  return encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
}
export function svgLeafletText(words, width, height) {
  words = words.reduce((str, v) => {
    str += str === '' ? v : `<tspan x="0" dy="1em">${v}</tspan>`
    return str
  }, '')
  const svgrect = `<svg viewBox="0 0 ${width} ${height}" width="${width}" height="${height}" fill="none" xmlns="http://www.w3.org/2000/svg"><text x="0" y="10" fill="rgba(255,255,255,0.9)" font-size="12" font-weight="400" font-family="Roboto, Arial, sans-serif">${words}</text></svg>`
  return encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
}

export function svgLeafletCircleIcon(leafletIconClass, color) {
  const CustomIcon = leafletIconClass.extend(infrustructureIconOptions)
  const svgrect =
    '<svg viewBox="0 0 46 46" width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="23" cy="23" r="19" fill="' +
    color +
    '"/><circle cx="23" cy="23" r="18" stroke="#FDFEFD" stroke-width="2"/></g><circle cx="23" cy="23" r="17" fill="' +
    color +
    '" stroke="#FDFEFD" stroke-width="2"/><defs><filter id="filter0_d" x="0" y="0" width="46" height="46" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0.12 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>'
  return new CustomIcon({
    iconUrl: encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
  })
}

export function svgLeafletSourceIcon(leafletIconClass, color) {
  const CustomIcon = leafletIconClass.extend({
    options: {
      iconSize: [12, 12],
      shadowSize: [0, 0],
      iconAnchor: [6, 6],
      shadowAnchor: [0, 0],
      popupAnchor: [0, -6]
    }
  })
  const svgrect =
    '<svg viewBox="0 0 12 12" width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="6" cy="6" r="5" stroke="#fff" stroke-width="2" fill="' +
    color +
    '"/></svg>'
  return new CustomIcon({
    iconUrl: encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
  })
}

export function svgLeafletTransportBaseIcon(leafletIconClass) {
  const CustomIcon = leafletIconClass.extend(infrustructureIconOptions)
  const svgrect =
    '<svg width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="23" cy="23" r="19" fill="#532FB3"/><circle cx="23" cy="23" r="18" stroke="#FDFEFD" stroke-width="2"/></g><path d="M31.633 25.364l-.866-2.598c-.197-.589-.814-1.033-1.434-1.033l-3.8-1.267c0-.698-.569-1.267-1.267-1.267L15.4 20.466c-.699 0-1.267.569-1.267 1.267v7.6c0 .698.569 1.266 1.267 1.266h1.375c.261.737.965 1.267 1.791 1.267s1.53-.53 1.791-1.267h3.91c.23 0 .446-.062.633-.17.186.107.402.17.633.17h1.375c.261.737.966 1.267 1.791 1.267.826 0 1.53-.53 1.791-1.267h.11c.697 0 1.266-.569 1.266-1.266v-2.534c0-.419-.1-1.036-.233-1.434zm-2.067-2.199l.366 1.1h-1.866v-1.267h1.267c.076 0 .209.096.233.167zm-11 7.433a.634.634 0 110-1.267.634.634 0 010 1.267zm1.791-1.267a1.902 1.902 0 00-1.79-1.266c-.827 0-1.531.53-1.792 1.266H15.4v-7.6l8.866-1.266v8.866h-3.909zm8.343 1.267a.634.634 0 110-1.267.634.634 0 010 1.267zm1.79-1.267a1.902 1.902 0 00-1.79-1.266c-.826 0-1.53.53-1.792 1.266h-1.375v-6.333h1.266v1.9c0 .35.284.633.634.633h2.92l.078.233c.09.269.167.752.167 1.034h-.633a.634.634 0 000 1.267h.633v1.266h-.107z" fill="#FDFEFD"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.648 10.44a.633.633 0 01.703 0l3.215 2.143v-.35c0-.35.283-.633.633-.633h2.39c.35 0 .634.283.634.633v2.788l4.528 3.018a.633.633 0 11-.703 1.054l-4.81-3.206a.633.633 0 01-.282-.527v-2.494h-1.123v.9a.633.633 0 01-.985.527l-3.849-2.566-11.048 7.366a.633.633 0 11-.703-1.054l11.4-7.6z" fill="#FDFEFD"/><defs><filter id="filter0_d" x="0" y="0" width="46" height="46" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0.12 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>'
  return new CustomIcon({
    iconUrl: encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
  })
}
export function svgLeafletTransportBase() {
  const svgrect =
    '<svg width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="23" cy="23" r="19" fill="#532FB3"/><circle cx="23" cy="23" r="18" stroke="#FDFEFD" stroke-width="2"/></g><path d="M31.633 25.364l-.866-2.598c-.197-.589-.814-1.033-1.434-1.033l-3.8-1.267c0-.698-.569-1.267-1.267-1.267L15.4 20.466c-.699 0-1.267.569-1.267 1.267v7.6c0 .698.569 1.266 1.267 1.266h1.375c.261.737.965 1.267 1.791 1.267s1.53-.53 1.791-1.267h3.91c.23 0 .446-.062.633-.17.186.107.402.17.633.17h1.375c.261.737.966 1.267 1.791 1.267.826 0 1.53-.53 1.791-1.267h.11c.697 0 1.266-.569 1.266-1.266v-2.534c0-.419-.1-1.036-.233-1.434zm-2.067-2.199l.366 1.1h-1.866v-1.267h1.267c.076 0 .209.096.233.167zm-11 7.433a.634.634 0 110-1.267.634.634 0 010 1.267zm1.791-1.267a1.902 1.902 0 00-1.79-1.266c-.827 0-1.531.53-1.792 1.266H15.4v-7.6l8.866-1.266v8.866h-3.909zm8.343 1.267a.634.634 0 110-1.267.634.634 0 010 1.267zm1.79-1.267a1.902 1.902 0 00-1.79-1.266c-.826 0-1.53.53-1.792 1.266h-1.375v-6.333h1.266v1.9c0 .35.284.633.634.633h2.92l.078.233c.09.269.167.752.167 1.034h-.633a.634.634 0 000 1.267h.633v1.266h-.107z" fill="#FDFEFD"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.648 10.44a.633.633 0 01.703 0l3.215 2.143v-.35c0-.35.283-.633.633-.633h2.39c.35 0 .634.283.634.633v2.788l4.528 3.018a.633.633 0 11-.703 1.054l-4.81-3.206a.633.633 0 01-.282-.527v-2.494h-1.123v.9a.633.633 0 01-.985.527l-3.849-2.566-11.048 7.366a.633.633 0 11-.703-1.054l11.4-7.6z" fill="#FDFEFD"/><defs><filter id="filter0_d" x="0" y="0" width="46" height="46" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0.12 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>'
  return encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
}

export function svgLeafletTriangleIcon(leafletIconClass, color = '#de8536') {
  const CustomIcon = leafletIconClass.extend(infrustructureIconOptions)
  const svgrect = svgTriangleIcon(color)
  return new CustomIcon({
    iconUrl: encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
  })
}
export function svgTriangleIcon(color = '#de8536') {
  return (
    '<svg viewBox="0 0 46 46" width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="23" cy="23" r="19" fill="' +
    color +
    '"/><circle cx="23" cy="23" r="18" stroke="#FDFEFD" stroke-width="2"/></g><path d="M23 11l11.258 19.5H11.742L23 11z" fill="#FDFEFD"/><defs><filter id="filter0_d" x="0" y="0" width="46" height="46" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0.12 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>'
  )
}

export function svgLeafletTriangleLinesIcon(leafletIconClass, color = '#de8536') {
  const CustomIcon = leafletIconClass.extend(infrustructureIconOptions)
  const svgrect = svgTriangleLinesIcon(color)
  return new CustomIcon({
    iconUrl: encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
  })
}
export function svgTriangleLinesIcon(color = '#de8536') {
  return '<svg width="46" height="47" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="23" cy="23.5" r="19" fill="#FDFEFD"/><circle cx="23" cy="23.5" r="18" stroke="#FDFEFD" stroke-width="2"/></g><path d="M13.5 32.472h19m-16.185-5.63h13.37m-10.555-5.63h7.74m-4.926-5.629h2.112" stroke="#606873" stroke-width="2.13" stroke-linecap="round"/><defs><filter id="filter0_d" x="0" y=".5" width="46" height="46" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0.12 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>'
}

export function svgLeafletRecycleIcon(leafletIconClass, color = '#de8536') {
  const CustomIcon = leafletIconClass.extend(infrustructureIconOptions)
  const svgrect = svgRecycleIcon(color)
  return new CustomIcon({
    iconUrl: encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
  })
}
export function svgRecycleIcon(color = '#de8536') {
  return (
    '<svg viewBox="0 0 46 46" width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="23" cy="23" r="19" fill="' +
    color +
    '"/><circle cx="23" cy="23" r="18" stroke="#FDFEFD" stroke-width="2"/></g><path d="M24.344 34.9a.672.672 0 01-.602-.373L22.4 31.841a.672.672 0 01.6-.971h5.373c1.896 0 3.303-.618 3.963-1.738.66-1.12.516-2.651-.406-4.308l-1.31-2.357a.672.672 0 011.175-.653l1.31 2.357c.573 1.033.899 2.048.966 3.015.069.976-.126 1.86-.577 2.627-.452.767-1.13 1.366-2.016 1.78-.879.412-1.924.62-3.105.62h-4.286l.857 1.714a.673.673 0 01-.6.972h0zM29.716 20.126a.671.671 0 01-.587-.345l-2.802-5.043c-.917-1.651-2.099-2.56-3.326-2.56-1.228 0-2.41.909-3.327 2.56l-1.31 2.357a.672.672 0 01-1.173-.653l1.31-2.357c1.164-2.097 2.762-3.252 4.5-3.252s3.336 1.155 4.5 3.252l2.184 3.93.774-1.548a.672.672 0 011.202.6l-1.343 2.687a.67.67 0 01-.586.37h-.015l-.001.002zM20.315 32.213h-2.686c-1.182 0-2.227-.208-3.106-.619-.886-.415-1.564-1.014-2.015-1.78-.452-.768-.646-1.651-.578-2.628.067-.967.392-1.98.967-3.015l2.247-4.045H13.6a.672.672 0 010-1.343h2.686a.67.67 0 01.587.997l-2.802 5.043c-.921 1.657-1.065 3.186-.406 4.308.66 1.121 2.067 1.738 3.964 1.738h2.686a.672.672 0 010 1.343v.001z" fill="#fff" stroke="#fff" stroke-width=".7"/><defs><filter id="filter0_d" x="0" y=".5" width="46" height="46" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0.12 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>'
  )
}

export function svgLeafletRecycleLinesIcon(leafletIconClass, color = '#de8536') {
  const CustomIcon = leafletIconClass.extend(infrustructureIconOptions)
  const svgrect = svgRecycleLinesIcon(color)
  return new CustomIcon({
    iconUrl: encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
  })
}
export function svgRecycleLinesIcon(color = '#de8536') {
  return '<svg width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="23" cy="23.5" r="19" fill="#FDFEFD"/><circle cx="23" cy="23.5" r="18" stroke="#FDFEFD" stroke-width="2"/></g><path d="M24.344 34.9a.672.672 0 01-.602-.373L22.4 31.841a.672.672 0 01.6-.971h5.373c1.896 0 3.303-.618 3.963-1.738.66-1.12.516-2.651-.406-4.308l-1.31-2.357a.672.672 0 011.175-.653l1.31 2.357c.573 1.033.899 2.048.966 3.015.069.976-.126 1.86-.577 2.627-.452.767-1.13 1.366-2.016 1.78-.879.412-1.924.62-3.105.62h-4.286l.857 1.714a.673.673 0 01-.6.972h0zM29.716 20.126a.671.671 0 01-.587-.345l-2.802-5.043c-.917-1.651-2.099-2.56-3.326-2.56-1.228 0-2.41.909-3.327 2.56l-1.31 2.357a.672.672 0 01-1.173-.653l1.31-2.357c1.164-2.097 2.762-3.252 4.5-3.252s3.336 1.155 4.5 3.252l2.184 3.93.774-1.548a.672.672 0 011.202.6l-1.343 2.687a.67.67 0 01-.586.37h-.015l-.001.002zM20.315 32.213h-2.686c-1.182 0-2.227-.208-3.106-.619-.886-.415-1.564-1.014-2.015-1.78-.452-.768-.646-1.651-.578-2.628.067-.967.392-1.98.967-3.015l2.247-4.045H13.6a.672.672 0 010-1.343h2.686a.67.67 0 01.587.997l-2.802 5.043c-.921 1.657-1.065 3.186-.406 4.308.66 1.121 2.067 1.738 3.964 1.738h2.686a.672.672 0 010 1.343v.001z" fill="#606873" stroke="#606873" stroke-width=".7"/><defs><filter id="filter0_d" x="0" y=".5" width="46" height="46" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0.12 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>'
}

export function svgLeafletTrianglesIcon(leafletIconClass, color = '#522fb3') {
  const CustomIcon = leafletIconClass.extend(infrustructureIconOptions)
  const svgrect = svgTrianglesIcon(color)
  return new CustomIcon({
    iconUrl: encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
  })
}
export function svgTrianglesIcon(color = '#522fb3') {
  return (
    '<svg viewBox="0 0 46 46" width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="23" cy="23" r="19" fill="' +
    color +
    '"/><circle cx="23" cy="23" r="18" stroke="#FDFEFD" stroke-width="2"/></g><path d="M17.5 23l4.763 8.25h-9.526L17.5 23zM28.5 23l4.763 8.25h-9.526L28.5 23zM23 12l4.556 8.609h-9.112L23 12z" fill="#FDFEFD"/><defs><filter id="filter0_d" x="0" y="0" width="46" height="46" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0.12 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>'
  )
}

export function svgLeafletTrianglesLinesIcon(leafletIconClass, color) {
  const CustomIcon = leafletIconClass.extend(infrustructureIconOptions)
  const svgrect = svgTrianglesLinesIcon(color)
  return new CustomIcon({
    iconUrl: encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
  })
}
export function svgTrianglesLinesIcon(color) {
  return '<svg width="46" height="47" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="23" cy="23.5" r="19" fill="#FDFEFD"/><circle cx="23" cy="23.5" r="18" stroke="#FDFEFD" stroke-width="2"/></g><path d="M10.333 36.589h9.5m-6.685-5.63h3.87m-1.23-5.63h-.177m11.435 11.26h9.5m-6.685-5.63h3.87m-2.017-5.63h-.174m-12.674-4.82h9.5m-6.685-5.63h3.87M23.528 9.25h-.174" stroke="#606873" stroke-width="2.13" stroke-linecap="round"/><defs><filter id="filter0_d" x="0" y=".5" width="46" height="46" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0.12 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>'
}

export function svgLeafletPentaganIcon(leafletIconClass, color = '#db3283', strokeColor = '#FDFEFD') {
  const CustomIcon = leafletIconClass.extend(infrustructureIconOptions)
  const svgrect = svgPentaganIcon(color, strokeColor)
  return new CustomIcon({
    iconUrl: encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
  })
}
export function svgPentaganIcon(color = '#db3283', strokeColor = '#FDFEFD') {
  return (
    '<svg viewBox="0 0 46 46" width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="23" cy="23" r="19" fill="' +
    color +
    '"/><circle cx="23" cy="23" r="18" stroke="#FDFEFD" stroke-width="2"/></g><path d="M11.812 19.365L23 11.236l11.188 8.129-4.273 13.152h-13.83l-4.273-13.152z" stroke="' +
    strokeColor +
    '" stroke-width="1"/><defs><filter id="filter0_d" x="0" y="0" width="46" height="46" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0.12 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>'
  )
}

export function svgLeafletPentaganLinesIcon(leafletIconClass, color = '#db3283', strokeColor = '#FDFEFD') {
  const CustomIcon = leafletIconClass.extend(infrustructureIconOptions)
  const svgrect = svgPentaganLinesIcon(color, strokeColor)
  return new CustomIcon({
    iconUrl: encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
  })
}
export function svgPentaganLinesIcon(color = '#db3283', strokeColor = '#FDFEFD') {
  return '<svg width="46" height="47" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="23" cy="23.5" r="19" fill="#FDFEFD"/><circle cx="23" cy="23.5" r="18" stroke="#FDFEFD" stroke-width="2"/></g><path d="M15.692 36.167h14.616m-16.402-5.07h18.188m-19.974-5.07h21.76m-23.547-5.07h25.334m-18.838-5.062h12.342m-6.496-5.06l.65-.002" stroke="#606873" stroke-width="2.13" stroke-linecap="round"/><defs><filter id="filter0_d" x="0" y=".5" width="46" height="46" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0.12 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>'
}

export function svgLeafletSquaresIcon(leafletIconClass, color = '#ffe100') {
  const CustomIcon = leafletIconClass.extend(infrustructureIconOptions)
  const svgrect = svgSquaresIcon(color)
  return new CustomIcon({
    iconUrl: encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
  })
}
export function svgSquaresIcon(color = '#ffe100') {
  return (
    '<svg viewBox="0 0 46 46" width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="23" cy="23" r="19" fill="' +
    color +
    '"/><circle cx="23" cy="23" r="18" stroke="#FDFEFD" stroke-width="2"/></g><path fill="#FDFEFD" d="M18 13h10v8H18zM12 23h10v8H12zM24 23h10v8H24z"/><defs><filter id="filter0_d" x="0" y="0" width="46" height="46" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0.12 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>'
  )
}

export function svgLeafletSquaresLinesIcon(leafletIconClass, color) {
  const CustomIcon = leafletIconClass.extend(infrustructureIconOptions)
  const svgrect = svgSquaresLinesIcon(color)
  return new CustomIcon({
    iconUrl: encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
  })
}

export function svgSquaresLinesIcon(color) {
  return '<svg width="46" height="47" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="23" cy="23.5" r="19" fill="#FDFEFD"/><circle cx="23" cy="23.5" r="18" stroke="#FDFEFD" stroke-width="2"/></g><path d="M11.92 33.342h8.614m-8.617-5.63h8.62m5.19 5.63h8.613m-8.617-5.63h8.62m-15.65-8.082h8.614M18.69 14h8.62" stroke="#606873" stroke-width="2.13" stroke-linecap="round"/><defs><filter id="filter0_d" x="0" y=".5" width="46" height="46" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0.12 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>'
}

export function svgLeafletClusterIcon(leaflet, number) {
  const color = number <= 10 ? '#a0cf75' : number > 100 ? '#e4995e' : '#e7c961'
  return leaflet.divIcon({
    className: '',
    iconSize: [70, 70],
    html:
      '<div style="position:relative;"><div style="width:70px;height:70px;position:absolute;border-radius:50%;background: ' +
      color +
      '; opacity: 0.3;"></div><div style="position: absolute;height: 50px;width: 50px;top: 10px;left: 10px;border-radius: 50%;line-height: 50px;font-size: 18px;text-align: center;font-weight: bold;font-family: \'Roboto\', sans-serif;background: ' +
      color +
      '">' +
      number +
      '</div></div>'
  })
}
export function svgLeafletCluster(number) {
  const color = number <= 10 ? '#a0cf75' : number > 100 ? '#e4995e' : '#e7c961'
  let svg = '<svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">'
  svg += '<circle opacity="0.3" cx="35" cy="35" r="35" fill="' + color + '"/>'
  svg += '<circle cx="35" cy="35" r="26" fill="' + color + '"/>'
  svg +=
    '<text x="35" y="37" dominant-baseline="middle" text-anchor="middle" style="fill: #2F3541; stroke: none; font-size: 16px; line-height: 12px; font-weight: bold; font-family: \'Roboto\', sans-serif;">' +
    number +
    '</text>'
  svg += '</svg>'
  return encodeURI('data:image/svg+xml,' + svg).replace(new RegExp('#', 'g'), '%23')
}

export function detailCluster(leaflet, objects = [], types = []) {
  let html = ''
  // generate main svg object in the center
  const text =
    '<text x="23" y="28" fill="rgb(47,53,65)" font-size="14" font-weight="700" font-family="Roboto, Arial, sans-serif" text-anchor="middle">' +
    objects.length +
    '</text>'
  const mainClusterSvg =
    '<svg viewBox="0 0 46 46" width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><g><circle cx="23" cy="23" r="19" fill="rgb(253,254,253)"/><circle cx="23" cy="23" r="18" stroke="rgb(253,254,253)" stroke-width="2"/></g>' +
    text +
    '<defs><filter id="filter0_d" x="0" y="0" width="70" height="70" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0.12 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>'
  const mainClusterHtml = '<div class="ClusterDetails-cluster">' + mainClusterSvg + '</div>'
  // get points
  const step = ((360 / objects.length) * Math.PI) / 180
  const coordinates = []
  const lines = []
  objects.forEach((object, index) => {
    coordinates.push({
      x: 75 + 52 * Math.cos(-step * index),
      y: 75 + 52 * Math.sin(step * index)
    })
  })
  // generage svg with all lines
  coordinates.forEach((line) => {
    lines.push('<line x1="75" y1="75" x2=' + line.x + ' y2="' + line.y + '" stroke="rgb(96,104,115)" />')
  })
  const linesSvg = '<svg viewBox="0 0 150 150" width="150" height="150" fill="none" xmlns="http://www.w3.org/2000/svg">' + lines.join('') + '</svg>'

  // generate svgs with objects
  const objectsHtml = []
  objects.forEach((object, index) => {
    let icon = ''
    const infType = types.filter((v) => object.rank >= v.min_rank && object.rank < v.max_rank)[0].label
    if (infType === 'assortment' || infType === 'recast') {
      icon =
        object.status === 'closed' || object.status === 'unused'
          ? svgTrianglesIcon('#5f646b')
          : object.status === 'planned'
          ? svgTrianglesIcon('#b1b2b5')
          : object.status === 'awaiting'
          ? svgTrianglesLinesIcon(object.color)
          : svgTrianglesIcon(object.color)
    } else if (infType === 'disposal') {
      icon =
        object.status === 'closed' || object.status === 'unused'
          ? svgPentaganIcon('#5f646b')
          : object.status === 'planned'
          ? svgPentaganIcon('#b1b2b5', '#5f646b')
          : object.status === 'awaiting'
          ? svgPentaganLinesIcon(object.color)
          : svgPentaganIcon(object.color)
    } else if (infType === 'placement') {
      icon =
        object.status === 'closed' || object.status === 'unused'
          ? svgTriangleIcon('#5f646b')
          : object.status === 'planned'
          ? svgTriangleIcon('#b1b2b5')
          : object.status === 'awaiting'
          ? svgTriangleLinesIcon(object.color)
          : svgTriangleIcon(object.color)
    } else if (infType === 'recycle') {
      icon =
        object.status === 'closed' || object.status === 'unused'
          ? svgRecycleIcon('#5f646b')
          : object.status === 'planned'
          ? svgRecycleIcon('#b1b2b5')
          : object.status === 'awaiting'
          ? svgRecycleLinesIcon(object.color)
          : svgRecycleIcon(object.color)
    } else {
      icon =
        object.status === 'closed' || object.status === 'unused'
          ? svgSquaresIcon('#5f646b')
          : object.status === 'planned'
          ? svgSquaresIcon('#b1b2b5')
          : object.status === 'awaiting'
          ? svgSquaresLinesIcon(object.color)
          : svgSquaresIcon(object.color)
    }
    const html =
      '<div class="ClusterDetails-object" data-infrastructure="' +
      object.id +
      '" style="left: ' +
      coordinates[index].x +
      'px; top: ' +
      coordinates[index].y +
      'px">' +
      icon +
      '</div>'
    objectsHtml.push(html)
  })

  const finalIcon = leaflet.divIcon({
    className: 'LeafletClusterDetails',
    iconSize: [46, 46],
    html: '<div class="ClusterDetails">' + mainClusterHtml + linesSvg + objectsHtml.join('') + '</div>'
  })
  return finalIcon
}

export function styleLeafletZoomControls(map) {
  map.zoomControl.setPosition('topright')
  map.zoomControl.getContainer().classList.add('ZoomControls')

  let zoomInElement = map.zoomControl.getContainer().getElementsByClassName('leaflet-control-zoom-in')[0]
  zoomInElement.innerHTML = '<i class="Icon IconMapPlus"></i>'
  zoomInElement.title = 'Приблизить'

  let zoomOutElement = map.zoomControl.getContainer().getElementsByClassName('leaflet-control-zoom-out')[0]
  zoomOutElement.innerHTML = '<i class="Icon IconMapMinus"></i>'
  zoomOutElement.title = 'Отдалить'
}

export function stylePrintControl() {
  Array.from(document.getElementsByClassName('leaflet-browser-print')).forEach((v) => {
    v.innerHTML = '<i class="Icon IconPrint"></i>'
  })
}

export function styleLayerControl(title = 'Слои') {
  Array.from(document.getElementsByClassName('leaflet-control-layers')).forEach((v) => {
    v.classList.add('LayersControl')
    v.children[0].setAttribute('title', title)
  })

  Array.from(document.getElementsByClassName('leaflet-control-layers-toggle')).forEach((v) => {
    v.innerHTML = '<i class="Icon IconLayers"></i>'
  })
}

export function svgRouteIcon(leafletIconClass, color) {
  const CustomIcon = leafletIconClass.extend({
    options: {
      iconSize: [18, 19],
      shadowSize: [0, 0],
      iconAnchor: [9, 9],
      shadowAnchor: [0, 0]
    }
  })
  const svgrect =
    '<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<circle stroke="' +
    color +
    '" stroke-width="2" class="st0" cx="10" cy="9" r="8"/>' +
    '<circle fill="#FDFEFD" cx="10" cy="9" r="7"/>' +
    '<path fill="' +
    color +
    '" d="M10.3,3.1C10.2,3,10.1,3,10,3C9.9,3,9.8,3,9.8,3.1L7,13.8c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0,0.3,0l2.7-2.7l2.7,2.7c0.1,0.1,0.2,0.1,0.3,0c0,0,0,0,0.1,0c0.1-0.1,0.1-0.2,0.1-0.2L10.3,3.1z"/>' +
    '</svg>'
  return new CustomIcon({
    iconUrl: encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
  })
}

export function svgFlow(color, strokeWidth) {
  const svgrect =
    '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">' +
    '<path d="M1.5,6.3l3-3l3,3" stroke="' +
    color +
    '" stroke-width="' +
    strokeWidth +
    '" stroke-linecap="round"/>' +
    '</svg>'
  return encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
}

export function generateRoutePopup(properties) {
  const typeName = {
    transfer: 'Маршрут перевозки',
    removaltrip: 'Маршрут вывоза',
    collectingloop: 'Петля сбора'
  }
  const typeIcons = {
    transfer: 'IconLayerTransfer',
    removaltrip: 'IconLayerRTrip',
    collectingloop: 'IconLayerLoop'
  }
  const finalRouteLength = properties.route.removaltrip.length + properties.route.transfer.length + properties.route.collectingloop.length
  let html = '<div class="LeafletPopup-main LeafletRouterPopup">'
  if (finalRouteLength > 1) {
    const typeCount = [
      {
        icon: typeIcons.transfer,
        count: properties.route.transfer.length
      },
      {
        icon: typeIcons.removal_trip,
        count: properties.route.removaltrip.length
      },
      {
        icon: typeIcons.collecting_loop,
        count: properties.route.collectingloop.length
      }
    ]
    html += '<div class="LeafletRouterPopup-title">'
    typeCount.forEach((v) => {
      if (v.count > 0) {
        html += '<span><i class="Icon ' + v.icon + '"></i>' + v.count + '</span>'
      }
    })
    html += '</div>'
  } else {
    const type = properties.route.removaltrip.length > 0 ? 'removaltrip' : properties.route.transfer.length > 0 ? 'transfer' : 'collectingloop'
    html += '<div class="LeafletPopup-title">' + typeName[type] + '</div>'
    html += '<div><b> № ' + properties.route[type].join(', ')
    html += '</b></div>'
  }
  html += '</div>'
  return html
}
export function generateStreaminfoPopup(properties) {
  let html =
    '<div class="LeafletPopup-main"><div class="LeafletPopup-title">Линейный информационный слой</div><div class="LeafletPopup-text">' +
    properties.streaminfo.name +
    '</div>'
  if (properties.streaminfo.distance) {
    html += '<div class="LeafletPopup-description">Длина маршрута: ' + properties.streaminfo.distance + '</div>'
  }
  html += '</div>'
  return html
}
export function generateFlowPopup(properties, problemsMap, hideItems = false, hideProblems = false) {
  let html = '<div class="LeafletPopup-main">'
  html +=
    '<div class="LeafletPopup-title">' +
    (properties.flow.flows.length > 1 ? 'Потоки отходов: ' + properties.flow.flows.length + 'шт.' : 'Поток отходов') +
    '</div>'
  html +=
    '<div class="LeafletPopup-text"> От ' + (properties.flow.source || 'Без названия') + ' к ' + (properties.flow.destination || 'Без названия') + '</div>'

  if (!hideProblems) {
    properties.flow.problems.forEach((problem) => {
      let problemName = problemsMap[problem]
      if (typeof problemName === 'object') {
        problemName = problemName.name
      }

      if (problem !== 'no_problem') {
        html += '<div class="LeafletPopup-warning">' + problemName + '</div>'
      }
    })
  }

  if (Array.isArray(properties.flow.items)) {
    //Не отображаем предметы с нулевым процентом
    const flowItems = properties.flow.items.filter((flowItem) => {
      return parseFloat(flowItem.item_ratio) > 0
    })

    if (flowItems.length > 0) {
      //Форматируем массу и объем
      const numberFormat = new Intl.NumberFormat('ru-RU', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
      })

      //Отображение массы
      if (properties.flow.mass) {
        const massString = numberFormat.format(properties.flow.mass).replace(',', '.')
        html += `<div class="LeafletPopupFlowItem">
          <div class="LeafletPopupFlowItem-text">Масса</div>
          <div class="LeafletPopupFlowItem-quantity">${massString} ${properties.flow.mass_designation}</div>
          </div>`
      }

      //Отображение объема
      if (properties.flow.volume) {
        const volumeString = numberFormat.format(properties.flow.volume).replace(',', '.')
        html += `<div class="LeafletPopupFlowItem">
          <div class="LeafletPopupFlowItem-text">Объем</div>
          <div class="LeafletPopupFlowItem-quantity">${volumeString} ${properties.flow.volume_designation}</div>
          </div>`
      }

      if (!hideItems) {
        html += '<div class="LeafletPopup-subtitle">Состав</div>'
        html += '<div class="LeafletPopup-flows">'
        flowItems.forEach((v) => {
          html +=
            '<div class="LeafletPopupFlowItem"><div class="LeafletPopupFlowItem-color" style="background: ' +
            v.item_color +
            '"></div><div class="LeafletPopupFlowItem-text">' +
            (v.item_name || 'Без названия') +
            '</div><div class="LeafletPopupFlowItem-quantity">' +
            v.item_ratio +
            '</div></div>'
        })
        html += '</div>'
      }
    }
  }
  html += '</div>'
  html += '<div class="LeafletPopup-coordinates"> Уровень:' + properties.flow.level + '</div>'
  return html
}
export function generateInfrastructurePopup(properties, treatmentsMap, colors, hideTreatments = false) {
  let treatmentsIn = ''
  let treatmentsOut = ''
  if (properties.infrastructures && properties.count === 1) {
    properties.infrastructures.forEach((infrastructure) => {
      infrastructure.treatment_input = infrastructure.treatment_input ? infrastructure.treatment_input.filter((v) => treatmentsMap[v]) : []
      if (infrastructure.treatment_input.length > 0 && !hideTreatments) {
        treatmentsIn = '<div class="LeafletPopup-treatments">Вход: '
        infrastructure.treatment_input
          .filter((v) => treatmentsMap[v])
          .forEach((treatment) => {
            const color = colors[treatmentsMap[treatment].color] ? colors[treatmentsMap[treatment].color].hex : ''
            treatmentsIn +=
              '<div class="LeafletPopup-treatment" title = "' +
              (treatmentsMap[treatment].ru_name || 'Без названия') +
              '" style="background:' +
              color +
              '"></div>'
          })
        treatmentsIn += '</div>'
      }
      infrastructure.treatment_output = infrastructure.treatment_output ? infrastructure.treatment_output.filter((v) => treatmentsMap[v]) : []
      if (infrastructure.treatment_output.length > 0 && !hideTreatments) {
        treatmentsOut = '<div class="LeafletPopup-treatments">Выходы: '
        infrastructure.treatment_output.forEach((treatment) => {
          const color = colors[treatmentsMap[treatment].color] ? colors[treatmentsMap[treatment].color].hex : ''
          treatmentsOut +=
            '<div class="LeafletPopup-treatment" title = "' + (treatmentsMap[treatment].ru_name || 'Без названия') + '" style="background:' + color + '"></div>'
        })
        treatmentsOut += '</div>'
      }
    })
  }
  const treatments = treatmentsIn + treatmentsOut
  const html =
    '<div class="LeafletPopup-main"><div class="LeafletPopup-title">' +
    properties.title +
    '</div><div class="LeafletPopup-text">' +
    properties.text +
    '</div>' +
    treatments +
    '</div><div class="LeafletPopup-coordinates">' +
    formatPoint(properties.coordinates) +
    '</div>'
  return html
}

export function svg3DSourceIcon(color) {
  const svgrect =
    '<svg viewBox="0 0 12 12" width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="6" cy="6" r="5" stroke="#fff" stroke-width="2" fill="' +
    color +
    '"/></svg>'
  return encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
}
export function svg3DClusterIcon(number) {
  const text =
    '<text x="35" y="42" fill="rgb(47,53,65)" font-size="20" font-weight="700" font-family="Roboto, Arial, sans-serif" text-anchor="middle">' +
    number +
    '</text>'
  const svgrect =
    '<svg viewBox="0 0 70 70" width="70" height="70" fill="none" xmlns="http://www.w3.org/2000/svg"><g><circle cx="35" cy="35" r="29" fill="rgb(253,254,253)"/><circle cx="35" cy="35" r="28" stroke="rgb(253,254,253)" stroke-width="2"/></g>' +
    text +
    '<defs><filter id="filter0_d" x="0" y="0" width="70" height="70" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0.12 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>'
  return encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
}

export function svg3DTriangleIcon(color = '#de8536') {
  const svgrect = svgTriangleIcon(color)
  return encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
}

export function svg3DTriangleLinesIcon(color = '#de8536') {
  const svgrect = svgTriangleLinesIcon(color)
  return encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
}
export function svg3DRecycleIcon(color = '#de8536') {
  const svgrect = svgRecycleIcon(color)
  return encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
}

export function svg3DRecycleLinesIcon(color = '#de8536') {
  const svgrect = svgRecycleLinesIcon(color)
  return encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
}

export function svg3DTrianglesIcon(color = '#522fb3') {
  const svgrect = svgTrianglesIcon(color)
  return encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
}

export function svg3DTrianglesLinesIcon(color) {
  const svgrect = svgTrianglesLinesIcon(color)
  return encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
}

export function svg3DPentaganIcon(color = '#db3283', strokeColor = '#FDFEFD') {
  const svgrect = svgPentaganIcon(color, strokeColor)
  return encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
}

export function svg3DPentaganLinesIcon(color = '#db3283', strokeColor = '#FDFEFD') {
  const svgrect = svgPentaganLinesIcon(color, strokeColor)
  return encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
}

export function svgText(text, color) {
  const svgText = '<text x="0" y ="17" fill="' + color + '" font-size="14" font-family="Roboto, Arial, sans-serif">' + text + '</text>'
  const svgrect =
    '<svg viewBox="0 0 ' +
    text.length * 10 +
    ' 20" width="' +
    text.length * 10 +
    '" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    svgText +
    '</svg>'
  return encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
}
export function svgRectangle(color) {
  const svgrect =
    '<svg viewBox="0 0 13 2" width="13" height="2" fill="none" xmlns="http://www.w3.org/2000/svg"><rect fill="' +
    color +
    '" x="0" y="0" width="13" height="2" /></svg>'
  return encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
}

export function svg3DSquaresIcon(color = '#ffe100') {
  const svgrect = svgSquaresIcon(color)
  return encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
}

export function svg3DSquaresLinesIcon(color) {
  const svgrect = svgSquaresLinesIcon(color)
  return encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
}

export function calculateOffset(polyline, offset) {
  if (!polyline || polyline.length < 1) {
    return
  }

  const translatePoint = function(pt, dist, heading) {
    return {
      x: pt.x + dist * Math.cos(heading),
      y: pt.y + dist * Math.sin(heading)
    }
  }

  let offsetSegments = []
  for (let i = 1, l = polyline.length; i < l; i++) {
    const a = polyline[i - 1]
    const b = polyline[i]
    if (a.x === b.x && a.y === b.y) {
      return
    }

    // angles in (-PI, PI]
    const segmentAngle = Math.atan2(a.y - b.y, a.x - b.x)
    const offsetAngle = segmentAngle - Math.PI / 2

    offsetSegments.push({
      offsetAngle: offsetAngle,
      original: [a, b],
      offset: [translatePoint(a, offset, offsetAngle), translatePoint(b, offset, offsetAngle)]
    })
  }
}

export function svgLeafletAssortmentTechnologyIcon(leafletIconClass) {
  const CustomIcon = leafletIconClass.extend(infrustructureIconOptions)
  const svgrect = svgAssortmentTechnologyIcon()
  return new CustomIcon({
    iconUrl: encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
  })
}
export function svgAssortmentTechnologyIcon() {
  return '<svg viewBox="0 0 46 46" width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><style>.st2,.st3{fill:#fff}.st3{fill-rule:evenodd;clip-rule:evenodd}</style><circle cx="23" cy="23" r="19" fill="#db3283"/><circle cx="23" cy="23" r="18" fill="none" stroke="#fdfefd" stroke-width="2"/><path class="st2" d="M23.5 22.5v1h6c.3 0 .5.2.5.5v1.3h1V23c0-.3-.2-.5-.5-.5h-7z"/><path class="st2" d="M31 25.3h-1l-1.1-1.1c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l2 2c.2.2.5.2.7 0l2-2c.1-.1.1-.2.1-.4 0-.1 0-.3-.1-.4-.2-.2-.5-.2-.7 0L31 25.3zM23.5 23.5v-1h-8c-.3 0-.5.2-.5.5v2.3l-1.1-1.1c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l2 2c.2.2.5.2.7 0l2-2c.1-.1.1-.2.1-.4 0-.1 0-.3-.1-.4-.2-.2-.5-.2-.7 0L16 25.3V24c0-.3.2-.5.5-.5h6v1.8l-1.1-1.1c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l2 2c.2.2.5.2.7 0l2-2c.1-.1.1-.2.1-.4 0-.1 0-.3-.1-.4-.2-.2-.5-.2-.7 0l-1.1 1.1-.1-1.7z"/><path class="st3" d="M16.5 31.5c.3 0 .5-.2.5-.5v-2c0-.3-.2-.5-.5-.5h-2c-.3 0-.5.2-.5.5v2c0 .3.2.5.5.5h2zm-.5-2h-1v1h1v-1zM24 31.5c.3 0 .5-.2.5-.5v-2c0-.3-.2-.5-.5-.5h-2c-.3 0-.5.2-.5.5v2c0 .3.2.5.5.5h2zm-.5-2h-1v1h1v-1zM31.5 31.5c.3 0 .5-.2.5-.5v-2c0-.3-.2-.5-.5-.5h-2c-.3 0-.5.2-.5.5v2c0 .3.2.5.5.5h2zm-.5-2h-1v1h1v-1zM27.5 15v4c0 .2-.1.4-.3.5l-4 2h-.4l-4-2c-.2-.1-.3-.3-.3-.5v-4c0-.2.1-.4.3-.5l4-2h.4l4 2c.2.1.3.3.3.5zM23 13.5l2.7 1.5-2.7 1.5-2.7-1.5 2.7-1.5zm-3.5 2.2l3 1.6v2.9l-3-1.6v-2.9zm4 4.6v-2.9l3-1.6v2.9l-3 1.6z"/></svg>'
}

export function svgLeafletTransferTechnologyIcon(leafletIconClass) {
  const CustomIcon = leafletIconClass.extend(infrustructureIconOptions)
  const svgrect = svgTransferTechnologyIcon()
  return new CustomIcon({
    iconUrl: encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
  })
}
export function svgTransferTechnologyIcon() {
  return '<svg viewBox="0 0 46 46" width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><style>.st2{fill-rule:evenodd;clip-rule:evenodd}.st2,.st3{fill:#fff}</style><circle cx="23" cy="23" r="19" fill="#db3283"/><circle cx="23" cy="23" r="18" fill="none" stroke="#fdfefd" stroke-width="2"/><path class="st2" d="M29.9 15.3c-.2.1-.4.3-.4.5v.8c0 .2-.1.4-.4.5L16 21c-.2 0-.3.2-.2.4 0 .1.2.2.3.2h.9c.1 0 .2 0 .3.1.1 0 .1.1.1.1l3.3 4.8c.1.2.3.3.6.2l9.9-2.9c.2-.1.4-.3.4-.5l.2-7.3c0-.1 0-.2.1-.3 0-.1.1-.1.2-.2l.6-.4c.2-.1.2-.3.2-.5-.1-.2-.3-.3-.5-.2l-2.5.8zm-11.6 6l3 4.4 9.2-2.7.1-6.8h-.1v.4c0 .7-.4 1.3-1.1 1.4l-11.1 3.3z"/><path class="st3" d="M22.3 15.2L20 18c-.3.4.1.9.5.8l5.4-1.7c.5-.1.5-.8 0-.9l-3-1.2c-.2 0-.5 0-.6.2zM19.9 26.7l-.4-.7c-.1-.2-.3-.2-.4-.2-4.4.3-5.8 2.9-6 4.5 0 .3.2.5.5.5h5.5c.3 0 .6-.3.5-.6-.2-1.3-.1-2.1.3-2.6 0-.3.2-.6 0-.9z"/><path class="st2" d="M24.5 31.4c1.1 0 1.9-.9 1.9-1.9 0-1.1-.9-1.9-1.9-1.9-1.1 0-1.9.9-1.9 1.9 0 1.1.9 1.9 1.9 1.9zm0-1c.5 0 .9-.4.9-.9s-.4-.9-.9-.9-.9.4-.9.9.4.9.9.9z"/><path class="st3" d="M27.1 29.9v-.4c0-.8-.3-1.5-.9-1.9h6.2c.3 0 .5.2.5.5v1.3c0 .3-.2.5-.5.5h-5.3zM22 29.9h-.7c-.3 0-.5-.2-.5-.5v-1.3c0-.3.2-.5.5-.5h1.6c-.5.5-.9 1.2-.9 1.9-.1.1-.1.3 0 .4z"/></svg>'
}

export function svgLeafletDisposalTechnologyIcon(leafletIconClass) {
  const CustomIcon = leafletIconClass.extend(infrustructureIconOptions)
  const svgrect = svgDisposalTechnologyIcon()
  return new CustomIcon({
    iconUrl: encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
  })
}
export function svgDisposalTechnologyIcon() {
  return '<svg viewBox="0 0 46 46" width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><style>.st2{fill:#fff}</style><circle cx="23" cy="23" r="19" fill="#db3283"/><circle cx="23" cy="23" r="18" fill="none" stroke="#fdfefd" stroke-width="2"/><path class="st2" d="M31.5 33h-17c-.4 0-.8-.2-1.1-.5-.3-.3-.4-.7-.4-1.1l.8-11c0-.3.2-.5.5-.5h2.1c.3 0 .5.2.5.4l.9 7.2 4.3-2.6c.2-.1.3-.1.5 0s.3.3.3.4v2.1l4.2-2.5c.2-.1.3-.1.5 0s.3.3.3.4v2.1l4.2-2.5c.2-.1.3-.1.5 0s.3.3.3.4v6c.1 1-.6 1.7-1.4 1.7zM14.8 21L14 31.5c0 .1 0 .2.1.3.1.1.2.1.3.1h17c.3 0 .5-.2.5-.5v-5.1l-4.2 2.5c-.2.1-.3.1-.5 0s-.3-.3-.3-.4v-2.1l-4.2 2.5c-.2.1-.3.1-.5 0s-.3-.3-.3-.4v-2.1l-4.2 2.5c-.1.1-.3.1-.5 0s-.3-.2-.3-.4L16 21h-1.2zM15.5 19c-.3 0-.5-.2-.5-.5 0-3 2.5-5.5 5.5-5.5 1.2 0 2.3.4 3.3 1.1.2.2.3.5.1.7s-.5.3-.7.1c-.8-.6-1.7-.9-2.7-.9-2.5 0-4.5 2-4.5 4.5 0 .3-.3.5-.5.5zM28.5 18c-1.2 0-2.3-.4-3.3-1.1-.2-.2-.3-.5-.1-.7.2-.2.5-.3.7-.1.8.6 1.7.9 2.7.9 1.4 0 2.7-.7 3.6-1.8.2-.2.5-.3.7-.1.2.2.3.5.1.7-.5.7-1.2 1.2-1.9 1.6-.8.4-1.7.6-2.5.6z"/></svg>'
}

export function svgLeafletPlacementTechnologyIcon(leafletIconClass) {
  const CustomIcon = leafletIconClass.extend(infrustructureIconOptions)
  const svgrect = svgPlacementTechnologyIcon()
  return new CustomIcon({
    iconUrl: encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
  })
}
export function svgPlacementTechnologyIcon() {
  return '<svg viewBox="0 0 46 46" width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><style>.st2{fill:#fff}</style><circle cx="23" cy="23" r="19" fill="#db3283"/><circle cx="23" cy="23" r="18" fill="none" stroke="#fdfefd" stroke-width="2"/><path class="st2" d="M18.5 19.6c-1.8-1.6-3.8-.7-4.5 0 1.8-.9 3.8.4 4.5 1.1.9-1.6 3.4-1.4 4.5-1.1-1.8-1.6-3.7-.6-4.5 0zM24 15.6c-1.2-1.6-2.5-.7-3 0 1.2-.9 2.5.4 3 1.1.6-1.6 2.3-1.4 3-1.1-1.2-1.6-2.5-.6-3 0zM28 18.6c-1.2-1.6-2.5-.7-3 0 1.2-.9 2.5.4 3 1.1.6-1.6 2.3-1.4 3-1.1-1.2-1.6-2.5-.6-3 0zM20.9 23.4L13 31.2h1.5l7.1-7.1c.8-.8 2-.8 2.8 0l7.1 7.1H33l-7.9-7.9c-1.2-1.1-3-1.1-4.2.1z"/><path class="st2" d="M25.6 26.9L22 31.2h1.5l2.8-3.6c.4-.5 1.1-.5 1.5-.1l3.7 3.7H33l-4.5-4.5c-.8-.7-2.1-.7-2.9.2z"/></svg>'
}

export function svgLeafletRecycleTechnologyIcon(leafletIconClass) {
  const CustomIcon = leafletIconClass.extend(infrustructureIconOptions)
  const svgrect = svgRecycleTechnologyIcon()
  return new CustomIcon({
    iconUrl: encodeURI('data:image/svg+xml,' + svgrect).replace(new RegExp('#', 'g'), '%23')
  })
}
export function svgRecycleTechnologyIcon() {
  return '<svg viewBox="0 0 46 46" width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><style>.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}</style><circle cx="23" cy="23" r="19" fill="#db3283"/><circle cx="23" cy="23" r="18" fill="none" stroke="#fdfefd" stroke-width="2"/><path class="st2" d="M14 21v11h1V21h-1zm-.5-1c-.3 0-.5.2-.5.5v12c0 .3.2.5.5.5h2c.3 0 .5-.2.5-.5v-12c0-.3-.2-.5-.5-.5h-2zM31 21v11h1V21h-1zm-.5-1c-.3 0-.5.2-.5.5v12c0 .3.2.5.5.5h2c.3 0 .5-.2.5-.5v-12c0-.3-.2-.5-.5-.5h-2z"/><path class="st2" d="M31 22H15.4v-1H31v1zM31 26H15.4v-1H31v1zM31 30H15.4v-1H31v1z"/><path class="st2" d="M19.2 13.1c.2.1.3.4.2.7-.2.3-.4 1-.4 1.8.6-.1 1.2.1 1.6.2.4-.2 1-.4 1.5-.2.4.1.7.3.9.7.2.3.2.6.3 1 .2 0 .3.1.4.2.3.1.4.4.5.6.1.2.1.3.1.5h.1c.3 0 .6-.1.9 0 0-.3 0-.7.2-1 .3-.5.8-.8 1.6-.8.4 0 .7.1 1 .2.3.2.5.4.6.7.1.3.1.6.1.8.5.2.8.6 1 1l.3.9c0 .3.1.6 0 .8-.1.2-.3.3-.5.3h-1.9c-.2 0-.4-.1-.5-.3-.1-.4-.3-.5-.4-.6-.1-.1-.2-.1-.3-.1-.1 0-.3.1-.4.2-.1 0-.1.1-.1.1-.1.2-.3.2-.5.2-.3-.1-.4-.3-.4-.6.1-.4.1-.6 0-.7 0-.1-.1-.1-.1-.1-.1 0-.3-.1-.5 0-.2 0-.5.1-.7.2-.2.1-.4 0-.5-.1-.1-.1-.2-.3-.1-.5.1-.4.1-.6.1-.7 0 0 0-.1-.1-.1s-.2-.1-.4-.1c-.3 0-.5-.2-.5-.5 0-.5-.1-.8-.2-.9-.1-.1-.2-.2-.3-.2h-.4c.3.4.6 1 .6 1.8v.3c0 .5.1.8.1 1 .1.3.2.6.6 1 .1.1.1.4.1.5-.1.2-.3.3-.5.3h-3.1c-.1 0-.2 0-.2-.1-.3-.2-.8-.5-1.2-.8-.2-.2-.4-.3-.5-.5-.1.1-.2.1-.3.1v.1c-.1.2-.1.4-.1.7h-1c0-.3 0-.7.2-1.1.1-.2.2-.4.3-.5v-.1c0-.1 0-.2.1-.4l.3-.3v-1c.1-.6.4-1.3 1.2-1.7 0 0 .1 0 .1-.1 0-1.2.3-2.1.5-2.6.1-.3.4-.3.6-.2zm-1 3.8c-.3.2-.4.5-.5.8-.1.4 0 .9.1 1.1.1.3.3.6.7.9.3.3.7.5.9.7h2.1c-.1-.2-.2-.4-.2-.6-.1-.4-.1-.8-.2-1.2v-.3c-.1-.8-.5-1.4-.8-1.6-.2-.1-.7-.3-1.2-.2.1.9.5 1.8 1.3 2.8l-.7.7c-.9-1.1-1.3-2.1-1.5-3.1zM17 20.1zm9.2-.6c0-.1 0-.2-.1-.2v-.1c.2-.2.2-.5.1-.7 0-.2 0-.4.1-.5.1-.1.3-.3.8-.3.3 0 .4 0 .5.1.1 0 .1.1.2.2.1.2.1.5 0 .8 0 .2 0 .3.1.5.1.1.3.2.4.2.2 0 .4.1.6.5.1.2.2.4.2.6h-1c-.2-.4-.4-.6-.6-.8-.4-.2-.7-.3-1.1-.2 0-.1-.1-.1-.2-.1z"/></svg>'
}

export function detailTechnologyCluster(leaflet, objects = [], types = {}) {
  let html = ''
  // generate main svg object in the center
  const text =
    '<text x="23" y="28" fill="rgb(47,53,65)" font-size="14" font-weight="700" font-family="Roboto, Arial, sans-serif" text-anchor="middle">' +
    objects.length +
    '</text>'
  const mainClusterSvg =
    '<svg viewBox="0 0 46 46" width="46" height="46" fill="none" xmlns="http://www.w3.org/2000/svg"><g><circle cx="23" cy="23" r="19" fill="rgb(253,254,253)"/><circle cx="23" cy="23" r="18" stroke="rgb(253,254,253)" stroke-width="2"/></g>' +
    text +
    '<defs><filter id="filter0_d" x="0" y="0" width="70" height="70" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0.12 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>'
  const mainClusterHtml = '<div class="ClusterDetails-cluster">' + mainClusterSvg + '</div>'
  // get points
  const step = ((360 / objects.length) * Math.PI) / 180
  const coordinates = []
  const lines = []
  objects.forEach((object, index) => {
    coordinates.push({
      x: 75 + 52 * Math.cos(-step * index),
      y: 75 + 52 * Math.sin(step * index)
    })
  })
  // generage svg with all lines
  coordinates.forEach((line) => {
    lines.push('<line x1="75" y1="75" x2=' + line.x + ' y2="' + line.y + '" stroke="rgb(96,104,115)" />')
  })
  const linesSvg = '<svg viewBox="0 0 150 150" width="150" height="150" fill="none" xmlns="http://www.w3.org/2000/svg">' + lines.join('') + '</svg>'

  // generate svgs with objects
  const objectsHtml = []
  objects.forEach((object, index) => {
    let icon = ''
    const infType = types[object.convert_function].name
    if (infType.indexOf('transfer') > -1) {
      icon = svgTransferTechnologyIcon()
    } else if (infType.indexOf('placement') > -1) {
      icon = svgPlacementTechnologyIcon()
    } else if (infType.indexOf('disposal') > -1) {
      icon = svgDisposalTechnologyIcon()
    } else if (infType.indexOf('assortment') > -1) {
      icon = svgAssortmentTechnologyIcon()
    } else {
      icon = svgRecycleTechnologyIcon()
    }
    const html =
      '<div class="ClusterDetails-object" data-technology="' +
      object.id +
      '" data-infrastructure="' +
      object.infrastructureId +
      '" style="left: ' +
      coordinates[index].x +
      'px; top: ' +
      coordinates[index].y +
      'px">' +
      icon +
      '</div>'
    objectsHtml.push(html)
  })

  const finalIcon = leaflet.divIcon({
    className: 'LeafletClusterDetails',
    iconSize: [46, 46],
    html: '<div class="ClusterDetails">' + mainClusterHtml + linesSvg + objectsHtml.join('') + '</div>'
  })
  return finalIcon
}

function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  var angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0

  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  }
}

export function describeArc(x, y, radius, startAngle, endAngle) {
  var start = polarToCartesian(x, y, radius, endAngle)
  var end = polarToCartesian(x, y, radius, startAngle)

  var largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1'

  var d = ['M', start.x, start.y, 'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y].join(' ')
  return d
}

export function prettifyCoordinates(coords) {
  return coords.map((v) => v.toFixed(5)).join(', ')
}

export function setFavicon(faviconUrl) {
  let link = document.querySelector("link[rel~='icon']")

  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.getElementsByTagName('head')[0].appendChild(link)
  }

  link.href = faviconUrl
}

const INFRASTRUCTURE_OBJECT_TYPE_ICONS = {
  transfer: 'SvgIconMapSquares',
  assortment: 'SvgIconMapTriangles',
  recast: 'SvgIconMapTriangles',
  disposal: 'SvgIconMapPentagan',
  placement: 'SvgIconMapTriangle',
  recycle: 'SvgIconMapRecycling'
}

/**
 * Получение иконки css для объектов инфраструктуры для ловой панели
 * @param {*} type
 * @param {*} status
 * @returns
 */
export function getInfrastructureObjectLegendIcon(type, status) {
  const icon = INFRASTRUCTURE_OBJECT_TYPE_ICONS[type]
  return `${icon} ${icon}--${status}`
}

/**
 * Установка вложенного свойства в объект vue по пути в виде массива
 * @param {*} obj
 * @param {*} propArr массив с названиями полей (путь к свойству, которое надо установить)
 * @param {*} value
 * @returns
 */
export function setPropByPath(obj, propPath, value) {
  let propArr = propPath.split(/\[|\]|\./).filter((item) => {
    return item !== ''
  })
  let propName = propArr.shift()

  if (propName) {
    if (Array.isArray(obj)) {
      propName = parseInt(propName) || 0
    }
    if (propArr.length) {
      if (obj[propName] === undefined) {
        Vue.set(obj, propName, {})
      }
      setPropByPath(obj[propName], propArr.join('.'), value)
    } else {
      if (Array.isArray(obj)) {
        if (propName > obj.length - 1) {
          obj.push(value)
        } else {
          obj.splice(propName, 1, value)
        }
      } else if (!obj.hasOwnProperty(propName)) {
        Vue.set(obj, propName, value)
      } else {
        obj[propName] = value
      }
    }
  }
  return obj
}

/**
 * Сравнить два массива без учета порядка элементов
 * @param {*} array1
 * @param {*} array2
 * @returns
 */
export function arraySameElements(array1, array2) {
  if (array1.length !== array2.length) {
    return false
  }

  for (let array1Item of array1) {
    if (!array2.includes(array1Item)) {
      return false
    }
  }

  return true
}
/**
 * Форматирование координат для попапа на карте
 */
export function formatPoint(pointCoordinate) {
  return pointCoordinate.map((coordinate) => coordinate.toFixed(5)).join(', ')
}

export function roundToEvent(val) {
  const roundedVal = Math.round(val)
  const difference = roundedVal - val

  if (Math.abs(difference) === 0.5) {
    if (roundedVal % 2 === 0) {
      return roundedVal
    }

    return Math.floor(val)
  }

  return roundedVal
}

/**
 * Ключ - название типа маршрута на клиенте, значение - название на сервере
 */
export const ROUTE_CLIENT_SERVER_NAME_MAPPING = {
  collectingloop: 'round', //Петли сбора
  transfer: 'cruise', //Маршруты перевозки
  removaltrip: 'trip' //Маршруты вывоза
}

/**
 * Функция округляет поле массива таким образом, чтобы в сумме получалось 100%, если предполагается что поле - это доля
 * @param {*} array массив объектов
 * @param {*} field поле объекта, в котором число меньше 1 - доля от общей суммы
 * @returns возвращает массив целых чисел, который в сумме дает 100%
 */
export function roundUpTo100percent(array, field) {
  //Массив в котором доли преведены к % (умножены на 100)
  const arrayInPercent = array.map((arrayItem) => {
    return arrayItem[field] * 100
  })

  //Получение целых частей
  let integerParts = arrayInPercent.map((arrayItem) => {
    return Math.floor(arrayItem)
  })

  //Получение дробных частей
  let decimalParts = arrayInPercent.map((arrayItem) => {
    return arrayItem - Math.floor(arrayItem)
  })

  //Расчитаем сумму целых частей
  let sum = arraySum(integerParts)
  let maxIndex

  //Пока сумма целых частей меньше 100
  while (sum < 100 && decimalParts.length > 0) {
    maxIndex = arrayMax(decimalParts).index //Находим максимальную дробную часть
    integerParts[maxIndex]++ //К соответствующей целой части прибавляем 1 (считай округляем в большую сторону)
    decimalParts.splice(maxIndex, 1) //Исключаем друбную часть из дальнейшего рассмотрения
    sum = arraySum(integerParts) //Считаем новую сумму целых частей
  }

  return integerParts
}

/**
 * Сумма элементов массива
 * @param {*} array
 * @returns
 */
function arraySum(array) {
  return array.reduce((sum, arrayItem) => {
    return sum + arrayItem
  }, 0)
}

/**
 * Максимальное число в массиве
 * @param {*} array
 * @returns возвращает объект с двумя полями: максимальное значение и индекс максимального значения
 */
function arrayMax(array) {
  return array.reduce(
    (result, arrayItem, index) => {
      if (arrayItem > result.value) {
        result.value = arrayItem
        result.index = index
      }
      return result
    },
    { value: Number.MIN_SAFE_INTEGER, index: -1 }
  )
}



// WEBPACK FOOTER //
// ./src/helpers/utils.js